/**
 * SELECTOR DE MOLIENDA PARA PRODUCTOS DE SUSCRIPCIÓN
 * Implementación para 69 Crazy Beans - Tema Local + Appstle Subscriptions
 * VERSIÓN 6.0 - Actualización estable y metadatos mejorados
 */

(function() {
  'use strict';

  // ========================================
  // CONFIGURACIÓN
  // ========================================
  
  const CONFIG = {
    subscriptionHandles: [
      'cafe-descafeinado-especialidad-colombia-500g-1',
      'cafe-ecologico-especialidad-colombia-500g-1',
      'cafe-especialidad-colombia-500g-1',
      'cafe-especialidad-india-500g-1',
      'cafe-especialidad-guatemala-500g-1',
      'cafe-descafeinado-especialidad-colombia-1-kg',
      'cafe-ecologico-especialidad-colombia-1k-suscripcion',
      'cafe-especialidad-colombia-1kg-suscripcion',
      'cafe-especialidad-india-1kg-suscripcion',
      'cafe-especialidad-guatemala-1kg-suscripcion'
    ],
    
    grindingOptions: [
  { value: '', label: 'En grano (sin moler)' },
  { value: 'espresso', label: 'Molido para Espresso' },
  { value: 'moka', label: 'Molido para Moka' },
  { value: 'chemex', label: 'Molido para Chemex' },
  { value: 'prensa-francesa', label: 'Molido para Prensa Francesa' }
],
    
    selectors: {
      checkoutButton: '#CheckOut',
      cartForm: 'form[action="/cart"]'
    },
    
    texts: {
      es: {
        mainTitle: '☕ ¿Quieres tu café molido?',
        mainDescription: 'Por defecto, tu café se entregará en grano. Si prefieres recibirlo molido, selecciona el tipo de molienda que necesitas para cada producto.',
        grindingLabel: 'Tipo de molienda',
        optional: '(Opcional)',
        unit: 'Unidad',
        defaultGrain: 'En grano'
      },
      en: {
        mainTitle: '☕ Would you like your coffee ground?',
        mainDescription: 'By default, your coffee will be delivered as whole beans. If you prefer it ground, select the grinding type you need for each product.',
        grindingLabel: 'Grinding type',
        optional: '(Optional)',
        unit: 'Unit',
        defaultGrain: 'Whole beans'
      }
    }
  };

  // ========================================
  // UTILIDADES
  // ========================================
  
  const Utils = {
    getLanguage() {
      return document.documentElement.lang === 'es' || 
             window.location.pathname.includes('/es/') ? 'es' : 'en';
    },
    
    getText(key) {
      const lang = this.getLanguage();
      return CONFIG.texts[lang][key] || CONFIG.texts.es[key];
    },
    
    generateSelectorId(handle, index) {
      return `grinding-selector-${handle}-${index}`;
    },
    
    saveToLocalStorage(data) {
      try {
        localStorage.setItem('cart_grinding_selections', JSON.stringify(data));
      } catch (e) {
        console.warn('No se pudo guardar en localStorage:', e);
      }
    },
    
    loadFromLocalStorage() {
      try {
        const data = localStorage.getItem('cart_grinding_selections');
        return data ? JSON.parse(data) : {};
      } catch (e) {
        return {};
      }
    },
    
    clearLocalStorage() {
      try {
        localStorage.removeItem('cart_grinding_selections');
      } catch (e) {
        console.warn('No se pudo limpiar localStorage:', e);
      }
    },
    
    // Generar hash del estado del carrito para detectar cambios reales
    generateCartHash(cartItems) {
      return cartItems.map(item => 
        `${item.variant_id}-${item.quantity}-${item.key}`
      ).join('|');
    }
  };

  // ========================================
  // GESTOR DE CARRITO
  // ========================================
  
  const CartManager = {
    currentCartHash: null,
    
    async getCartItems() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        return cart.items;
      } catch (error) {
        console.error('Error obteniendo carrito:', error);
        return [];
      }
    },
    
    needsGrindingSelection(handle) {
      return CONFIG.subscriptionHandles.includes(handle);
    },
    
    async updateCartAttributes(attributes) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes })
        });
        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error actualizando atributos del carrito:', error);
        return null;
      }
    },
    
    async updateLineItemProperties(lineItemKey, properties) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: lineItemKey,
            properties: properties
          })
        });
        const result = await response.json();
        return result;
      } catch (error) {
        console.error('Error actualizando propiedades del item:', error);
        return null;
      }
    }
  };

  // ========================================
  // GESTOR DE INTERFAZ
  // ========================================
  
  const UIManager = {
    isUpdating: false,
    
    createGrindingSelector(itemData) {
      const { handle, title, index, selectorId, variantId, lineItemKey } = itemData;
      
      const container = document.createElement('div');
      container.className = 'grinding-selector-container';
      container.setAttribute('data-grinding-selector', selectorId);
      container.setAttribute('data-variant-id', variantId);
      container.setAttribute('data-line-key', lineItemKey);
      container.style.cssText = `
        margin: 15px 0;
        padding: 15px;
        background-color: rgba(12, 35, 55, 0.04);
        border: 1px solid rgba(12, 35, 55, 0.15);
        border-radius: 5px;
      `;
      
      const label = document.createElement('label');
      label.htmlFor = selectorId;
      label.className = 'grinding-selector-label';
      label.style.cssText = `
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        color: #0c2337;
        font-weight: 500;
      `;
      label.innerHTML = `
        <strong>${Utils.getText('grindingLabel')}</strong>
        <span style="color: #6c757d; margin-left: 5px; font-size: 12px; font-weight: 400;">${Utils.getText('optional')}</span>
      `;
      
      const select = document.createElement('select');
      select.id = selectorId;
      select.name = selectorId;
      select.className = 'grinding-selector form__field';
      select.setAttribute('data-handle', handle);
      select.setAttribute('data-index', index);
      select.setAttribute('data-variant-id', variantId);
      select.setAttribute('data-line-key', lineItemKey);
      select.style.cssText = `
        width: 100%;
        padding: 10px 12px;
        border: 2px solid rgba(12, 35, 55, 0.3);
        border-radius: 5px;
        font-size: 16px;
        font-family: var(--font-stack-body, inherit);
        background-color: white;
        transition: all 0.3s ease;
        color: #0c2337;
      `;
      
      CONFIG.grindingOptions.forEach(option => {
        const optionEl = document.createElement('option');
        optionEl.value = option.value;
        optionEl.textContent = option.label;
        if (option.value === '') {
          optionEl.selected = true;
        }
        select.appendChild(optionEl);
      });
      
      select.addEventListener('change', () => {
        this.handleGrindingChange(select);
      });
      
      select.addEventListener('focus', () => {
        select.style.borderColor = '#0c2337';
        select.style.boxShadow = '0 0 0 3px rgba(12, 35, 55, 0.1)';
      });
      
      select.addEventListener('blur', () => {
        if (select.value) {
          select.style.borderColor = '#28a745';
          select.style.backgroundColor = '#f8fff9';
        } else {
          select.style.borderColor = 'rgba(12, 35, 55, 0.3)';
          select.style.backgroundColor = 'white';
        }
        select.style.boxShadow = 'none';
      });
      
      container.appendChild(label);
      container.appendChild(select);
      
      return container;
    },
    
    async handleGrindingChange(selectElement) {
      const selectorId = selectElement.id;
      const value = selectElement.value;
      const variantId = selectElement.getAttribute('data-variant-id');
      const lineItemKey = selectElement.getAttribute('data-line-key');
      const handle = selectElement.getAttribute('data-handle');
      
      const selections = Utils.loadFromLocalStorage();
      
      if (value) {
        selections[selectorId] = {
          value: value,
          variantId: variantId,
          lineItemKey: lineItemKey,
          handle: handle,
          label: selectElement.options[selectElement.selectedIndex].text
        };
      } else {
        delete selections[selectorId];
      }
      
      Utils.saveToLocalStorage(selections);
      
      if (value) {
        selectElement.style.borderColor = '#28a745';
        selectElement.style.backgroundColor = '#f8fff9';
      } else {
        selectElement.style.borderColor = 'rgba(12, 35, 55, 0.3)';
        selectElement.style.backgroundColor = 'white';
      }
      
      // Actualizar metadatos
      await this.updateCartWithSelections();
    },
    
    async updateCartWithSelections() {
      const selections = Utils.loadFromLocalStorage();
      const attributes = {};
      const lineItemUpdates = {};
      
      // Obtener items actuales del carrito
      const cartItems = await CartManager.getCartItems();
      const lineItemKeys = cartItems.map(item => item.key);
      
      // Limpiar selecciones de items que ya no existen en el carrito
      Object.keys(selections).forEach(selectorId => {
        const selection = selections[selectorId];
        if (!lineItemKeys.includes(selection.lineItemKey)) {
          delete selections[selectorId];
        }
      });
      
      Utils.saveToLocalStorage(selections);
      
      // Preparar atributos y propiedades
      Object.keys(selections).forEach(selectorId => {
        const selection = selections[selectorId];
        if (selection.value) {
          attributes[selectorId] = selection.value;
          
          if (!lineItemUpdates[selection.lineItemKey]) {
            lineItemUpdates[selection.lineItemKey] = {};
          }
          lineItemUpdates[selection.lineItemKey]['Tipo de molienda'] = selection.label;
        }
      });
      
      // Actualizar atributos del carrito
      await CartManager.updateCartAttributes(attributes);
      
      // Actualizar propiedades de cada line item
      for (const lineItemKey in lineItemUpdates) {
        await CartManager.updateLineItemProperties(lineItemKey, lineItemUpdates[lineItemKey]);
      }
      
      console.log('💾 Metadatos guardados:', {
        attributes: Object.keys(attributes).length,
        lineItems: Object.keys(lineItemUpdates).length
      });
    },
    
    restoreSelections() {
      const selections = Utils.loadFromLocalStorage();
      
      Object.keys(selections).forEach(selectorId => {
        const select = document.getElementById(selectorId);
        if (select && selections[selectorId] && selections[selectorId].value) {
          select.value = selections[selectorId].value;
          select.style.borderColor = '#28a745';
          select.style.backgroundColor = '#f8fff9';
        }
      });
    },
    
    async insertSelectorsDirectly(cartItems) {
      // Evitar actualizaciones concurrentes
      if (this.isUpdating) {
        console.log('⏸️ Actualización en progreso, omitiendo...');
        return;
      }
      
      this.isUpdating = true;
      
      try {
        // Verificar si realmente cambió el carrito
        const newHash = Utils.generateCartHash(cartItems);
        if (CartManager.currentCartHash === newHash) {
          console.log('✅ Carrito sin cambios, omitiendo actualización');
          this.isUpdating = false;
          return;
        }
        
        CartManager.currentCartHash = newHash;
        console.log('🔄 Carrito cambió, actualizando selectores...');
        
        const cartForm = document.querySelector('form[action="/cart"]') || 
                        document.querySelector('form#cart') ||
                        document.querySelector('.cart-section');
        
        if (!cartForm) {
          console.error('❌ No se encontró el formulario del carrito');
          this.isUpdating = false;
          return;
        }
        
        const oldContainer = document.getElementById('grinding-selectors-main-container');
        if (oldContainer) {
          oldContainer.remove();
        }
        
        const productsNeedingSelection = cartItems.filter(item => 
          CartManager.needsGrindingSelection(item.handle)
        );
        
        if (productsNeedingSelection.length === 0) {
          console.log('✅ No hay productos de café en el carrito');
          this.isUpdating = false;
          return;
        }
        
        let selectorIndex = 0;
        
        const mainContainer = document.createElement('div');
        mainContainer.id = 'grinding-selectors-main-container';
        mainContainer.style.cssText = `
          margin: 20px 0;
          padding: 20px;
          background-color: rgba(12, 35, 55, 0.02);
          border: 2px solid #0c2337;
          border-radius: 8px;
        `;
        
        const heading = document.createElement('h3');
        heading.textContent = Utils.getText('mainTitle');
        heading.style.cssText = `
          margin: 0 0 10px 0;
          font-size: 18px;
          color: #0c2337;
          font-weight: 600;
        `;
        mainContainer.appendChild(heading);
        
        const description = document.createElement('p');
        description.textContent = Utils.getText('mainDescription');
        description.style.cssText = `
          margin: 0 0 20px 0;
          font-size: 14px;
          color: #6c757d;
          line-height: 1.5;
        `;
        mainContainer.appendChild(description);
        
        productsNeedingSelection.forEach(cartItem => {
          for (let i = 0; i < cartItem.quantity; i++) {
            const productHeading = document.createElement('div');
            productHeading.style.cssText = `
              font-weight: 500;
              margin-bottom: 5px;
              color: #0c2337;
              font-size: 15px;
            `;
            productHeading.textContent = `${cartItem.product_title}${cartItem.quantity > 1 ? ` (${Utils.getText('unit')} ${i + 1})` : ''}`;
            
            const selectorId = Utils.generateSelectorId(cartItem.handle, selectorIndex);
            
            const selector = this.createGrindingSelector({
              handle: cartItem.handle,
              title: cartItem.product_title,
              index: selectorIndex,
              selectorId: selectorId,
              variantId: cartItem.variant_id,
              lineItemKey: cartItem.key
            });
            
            const wrapper = document.createElement('div');
            wrapper.style.marginBottom = '20px';
            wrapper.appendChild(productHeading);
            wrapper.appendChild(selector);
            
            mainContainer.appendChild(wrapper);
            
            selectorIndex++;
          }
        });
        
        const infoNote = document.createElement('div');
        infoNote.style.cssText = `
          margin-top: 15px;
          padding: 12px;
          background-color: #e7f3ff;
          border-left: 4px solid #0c2337;
          border-radius: 4px;
          font-size: 13px;
          color: #0c2337;
        `;
        infoNote.innerHTML = `
          <strong>ℹ️ Importante:</strong> Si no seleccionas ningún tipo de molienda, tu café se entregará <strong>en grano</strong> para que lo muelas cuando lo desees y mantenga todo su aroma y frescura.
        `;
        mainContainer.appendChild(infoNote);
        
        const aside = document.querySelector('.cart-section aside');
        
        if (aside) {
          aside.insertBefore(mainContainer, aside.firstChild);
        } else {
          const checkoutButton = document.querySelector('#CheckOut');
          if (checkoutButton && checkoutButton.parentElement) {
            checkoutButton.parentElement.insertBefore(mainContainer, checkoutButton);
          } else {
            cartForm.appendChild(mainContainer);
          }
        }
        
        // Restaurar selecciones
        setTimeout(() => {
          this.restoreSelections();
        }, 100);
        
        console.log('✅ Selectores actualizados correctamente');
        
      } finally {
        this.isUpdating = false;
      }
    }
  };

  // ========================================
  // OBSERVADOR DE CAMBIOS EN EL CARRITO
  // ========================================
  
  const CartObserver = {
    updateTimeout: null,
    lastCartState: null,
    
    init() {
      this.setupCartEventListeners();
      this.setupQuantityButtonListeners();
      
      // Verificación periódica suave cada 2 segundos
      setInterval(() => this.checkCartChanges(), 2000);
    },
    
    async checkCartChanges() {
      const cartItems = await CartManager.getCartItems();
      const newHash = Utils.generateCartHash(cartItems);
      
      if (this.lastCartState !== newHash) {
        this.lastCartState = newHash;
        await UIManager.insertSelectorsDirectly(cartItems);
      }
    },
    
    setupCartEventListeners() {
      document.addEventListener('cart:updated', () => {
        this.scheduleUpdate();
      });
    },
    
    setupQuantityButtonListeners() {
      document.addEventListener('click', (e) => {
        const button = e.target.closest('button[name="plus"], button[name="minus"], button.quantity__button');
        if (button) {
          this.scheduleUpdate();
        }
      });
      
      document.addEventListener('change', (e) => {
        if (e.target.matches('input[type="number"][name="updates[]"]') ||
            e.target.matches('input.quantity__input')) {
          this.scheduleUpdate();
        }
      });
    },
    
    scheduleUpdate() {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(async () => {
        const cartItems = await CartManager.getCartItems();
        await UIManager.insertSelectorsDirectly(cartItems);
      }, 1000);
    }
  };

  // ========================================
  // INICIALIZACIÓN
  // ========================================
  
  const GrindingSelector = {
    async init() {
      console.log('🔧 Iniciando selector de molienda v6.0...');
      
      const cartItems = await CartManager.getCartItems();
      
      if (cartItems.length === 0) {
        console.log('🛒 Carrito vacío');
        return;
      }
      
      const productsNeedingSelection = cartItems.filter(item => 
        CartManager.needsGrindingSelection(item.handle)
      );
      
      if (productsNeedingSelection.length === 0) {
        console.log('✅ No hay productos de café en el carrito');
        return;
      }
      
      await UIManager.insertSelectorsDirectly(cartItems);
      
      this.setupCheckoutListener();
      
      CartObserver.init();
      
      console.log('✅ Selector de molienda inicializado correctamente');
    },
    
    setupCheckoutListener() {
      const checkoutButton = document.querySelector(CONFIG.selectors.checkoutButton);
      if (checkoutButton) {
        checkoutButton.addEventListener('click', async (e) => {
          console.log('💾 Guardando selecciones finales...');
          await UIManager.updateCartWithSelections();
          
          setTimeout(() => {
            Utils.clearLocalStorage();
          }, 2000);
        });
      }
    }
  };

  // ========================================
  // EJECUTAR AL CARGAR
  // ========================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => GrindingSelector.init(), 500);
    });
  } else {
    setTimeout(() => GrindingSelector.init(), 500);
  }

})();